import React from 'react';
import BackButton from './Sub/BackButton';

import './SubNavigationBar.global.styl';

interface Props {
  children: React.ReactNode;
  className: string;
}

function SubNavigationBar({ children, className }: Props) {
  return <div className={`mio-sub-nav ${className}`}>{children}</div>;
}

SubNavigationBar.BackButton = BackButton;

SubNavigationBar.defaultProps = {
  className: '',
} as Partial<Props>;

export default SubNavigationBar;
